module.exports = __webpack_public_path__ + "img/yszc-qr.45497467.png";